// Webhook URL validation — mirrors backend services/common.utils.js#isValidWebhookUrl.
//
// HTTPS is always accepted. http:// is accepted when either:
//   - NODE_ENV !== 'production', OR
//   - REACT_APP_ALLOW_HTTP_WEBHOOKS=true at build time (explicit opt-in —
//     use this on pm2-dev because `react-scripts build` forces NODE_ENV=production
//     into the bundle, so the env check alone would block http://localhost URLs).
//
// Both env vars are inlined by CRA at build time; restart the build after changing them.
export const isHttpWebhookAllowed = () =>
    process.env.NODE_ENV !== 'production' || String(process.env.REACT_APP_ALLOW_HTTP_WEBHOOKS).toLowerCase() === 'true';

export const isValidWebhookUrl = (url) => {
    if (typeof url !== 'string' || !url) return false;
    if (url.startsWith('https://')) return true;
    return url.startsWith('http://') && isHttpWebhookAllowed();
};

export const webhookUrlHintText = () =>
    isHttpWebhookAllowed() ? 'Webhook URL must start with http:// or https://' : 'Webhook URL must start with https://';
